var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showChip)?_c('v-chip',{attrs:{"color":_vm.chipColour,"small":""}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.chipText)+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }